/**
 * @generated SignedSource<<34096284b9a0664c9d860051559bda2c>>
 * @relayHash 3df06541dfe0a6d1181c4c7c9f81284e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 60fb3dde117ac16d0451ee7871bf6b96e570a13b228e94f9d720b6b35a545957

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardQuery } from './src_jiraBusinessBoardQuery.graphql';

import isBusinessStatusMappingEnabled_provider from '@atlassian/jira-relay-provider/src/allow-status-mapping-on-business-board.relayprovider';
import isUsingNewCreate_provider from '@atlassian/jira-relay-provider/src/mbw-67-board-issue-create.relayprovider';
import withMergedWorkflows_provider from '@atlassian/jira-relay-provider/src/merge-board-workflows.relayprovider';
import isBusinessRelayBoardWorkflowEditingEnabled_provider from '@atlassian/jira-relay-provider/src/relay-board-workflow-editing.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "60fb3dde117ac16d0451ee7871bf6b96e570a13b228e94f9d720b6b35a545957",
    "metadata": {},
    "name": "src_jiraBusinessBoardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider": isBusinessStatusMappingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmbw67boardissuecreaterelayprovider": isUsingNewCreate_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcrelayboardworkfloweditingrelayprovider": isBusinessRelayBoardWorkflowEditingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": withMergedWorkflows_provider
    }
  }
};

export default node;
